import { Component, Input } from '@angular/core';
import { DataModalComponent } from 'src/app/components/modal/data-modal/data-modal.component';
import { DeeplinkPlayerModalComponent } from 'src/app/components/modal/deeplink-player-modal/deeplink-player-modal.component';
import { ModalService } from 'src/app/components/modal/modal.service';
import { ScheduleItemsModalComponent } from 'src/app/components/modal/schedule-items-modal/schedule-items-modal.component';

@Component({
    selector: 'app-ta-type-schedule-items',
    templateUrl: './ta-type-schedule-items.component.html',
    styleUrls: ['./ta-type-schedule-items.component.scss'],
})
export class TaTypeScheduleItemsComponent {
    @Input() callbackData: any;

    constructor(private modal: ModalService) {}

    ngOnInit() {
        console.log(this.callbackData);
    }

    deleteBtnAction() {
        if (this.callbackData) {
            this.callbackData[0].callback(this.callbackData[0].arg[0], this.callbackData[0].arg[1]);
        }
    }

    timeBtnAction() {
        this.modal.openModal({
            component: ScheduleItemsModalComponent,
            data: this.callbackData[1],
            prefix: 'category-visible-table-data',
        });
    }
}
